import classNames from 'classnames'
import { t } from 'i18next'
import React, { ReactNode } from 'react'
import { IconFa } from '../../atoms'
import styles from './index.module.css'

export type StatusVariant = 'success' | 'danger' | 'warning' | 'neutral'

interface Props {
  id?: string
  text?: string
  icon?: ReactNode
  noIcon?: boolean
  variant: StatusVariant
  className?: string
  border?: boolean
  selected?: boolean
  size?: 'large' | 'small'
  contentClassname?: string
}

export const Status: React.FC<Props> = ({ size = 'large', ...props }) => {
  const className = classNames(
    styles.status,
    styles[props.variant],
    (props.border || props.selected) && styles.hasBorder,
    styles[size],
    props.noIcon && styles.noIcon,
    props.contentClassname
  )

  return (
    <div id={props.id} className={classNames('inline-block', props.className)}>
      <div className={className}>
        <div className="flex items-center gap-2">
          {!props.noIcon && (props.icon ?? <Icon type={props.variant} />)}
          {props.text && props.text}
        </div>
      </div>
    </div>
  )
}

function Icon(props: { type: StatusVariant }) {
  switch (props.type) {
    case 'danger':
      return <IconFa icon={['fas', 'exclamation-triangle']} />
    case 'success':
      return <IconFa icon={['fas', 'check-circle']} />
    case 'warning':
    case 'neutral':
    default:
      return <IconFa icon={['fas', 'exclamation-circle']} />
  }
}

export const TableCellBooleanData = ({ condition, border }: { condition: boolean; border?: boolean }) =>
  condition ? (
    <Status variant="success" noIcon text={t('glow.yes')} border={border} />
  ) : (
    <Status variant="danger" text={t('glow.no')} noIcon border={border} />
  )
